import {ChartSeriesData, ChartSeriesType} from "@shared/components/canvas-chart/canvas-chart.component";
import {Equipment, FavouriteId, MeterUtilityType} from "@app/graphql-typings/graphql";
import {DataInterval, MeterConsumptionType} from "@app/layout/sitemanager/meters/meters.service";
import {MeterdataType} from "@app/shared/services/api/meter-provider.interface";
import {ChartDataSeriesOptions} from "canvasjs";
import {FunctionName} from "../chart-functions/chart-function-types";


export interface PointHistoryChartSeriesData extends ChartSeriesData {
  equipmentName: string;
  functionNameStr: string;
  /** Name of function to aggregate y axis values by */
  aggregationName: FunctionName | null;
  timePeriodStr: string;
}

export interface AlertPointHistoryChartSeriesData extends ChartSeriesData {
  templateName: string;
}

export interface MeterHistoryChartSeriesData extends ChartSeriesData {
  meterType: MeterUtilityType;
  unit: string;
  meterConsumptionType: MeterConsumptionType;
  aggregatePeriod: DataInterval;
  dataType: MeterdataType;
  forceChartType?: {
    type: ChartDataSeriesOptions['type'];
    markerType?: ChartDataSeriesOptions['markerType'];
  };
  compareToSeriesInfo?: {id: ChartSeriesData['id'], qualifier?: string}[];
}

export type ChartSeriesDataType = PointHistoryChartSeriesData | AlertPointHistoryChartSeriesData | MeterHistoryChartSeriesData;

export namespace ChartSeriesDataType {
  export function isPointHistory(seriesData: ChartSeriesDataType): seriesData is PointHistoryChartSeriesData {
    return seriesData?.type === ChartSeriesType.FAVOURITE;
  }

  export function isAlertHistory(seriesData: ChartSeriesDataType): seriesData is AlertPointHistoryChartSeriesData {
    return seriesData?.type === ChartSeriesType.ALERT;
  }

  export function isMeterHistory(seriesData: ChartSeriesDataType): seriesData is MeterHistoryChartSeriesData {
    return seriesData?.type === ChartSeriesType.METER_STREAM;
  }

  export function parse(seriesName: string): ChartSeriesDataType {
    return <ChartSeriesDataType>JSON.parse(seriesName);
  }

  export function buildKey(seriesData: ChartSeriesDataType): SeriesKey {
    return seriesData.id
      + (isPointHistory(seriesData) && seriesData.functionNameStr
        ? ('-' + seriesData.functionNameStr + (seriesData.timePeriodStr ? ('-' + seriesData.timePeriodStr) : ''))
        : '');
  }
}

export const ALERT_FAULT = 'Fault';
export const ALERT_NON_FAULT = 'Non-Fault';


export interface ValueBounds {
  minimum: number;
  maximum: number;
}


/** Value range floor a bin. i.e., for bin size 1.5, 0-1.5=0 */
export type BinValueFloor = number;


export type SeriesKey = string;


export interface BinStatistics {
  valueBounds: ValueBounds | null;
  xAxisSampleSizeByBinFloor: ReadonlyMap<BinValueFloor, number>;
  sampleSizeBySeriesKeyByBinFloor: ReadonlyMap<BinValueFloor, ReadonlyMap<SeriesKey, number>>;
}


export interface ValueBasedXAxisInfo {
  favouriteId: FavouriteId;
  equipment: Equipment;
  binSize: number;
  binStatistics: BinStatistics | null;
}
